module.exports = __webpack_public_path__ + "media/soundtrack.b6c6d11f.mp3";